import {
  SearchFilterType,
  renderFilterComponent,
  type SearchFilter,
  type SearchFilterBaseSections,
} from '@aibees/elephant/feature/search-filters';
import { useMemo } from 'react';

export function useRenderFilterContent(
  items: SearchFilter[],
  open: boolean,
  sections?: SearchFilterBaseSections,
  props?: Record<string, any>
) {
  return useMemo(
    () =>
      items?.map((item) => {
        if (item.type === SearchFilterType.NONE) {
          return item.items?.map((x) =>
            renderFilterComponent(
              x,
              open,
              x.sections ?? sections,
              undefined,
              props
            )
          );
        }

        return renderFilterComponent(
          item,
          open,
          item.sections ?? sections,
          undefined,
          props
        );
      }),
    [items, open, sections, props]
  );
}
